import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import { combineReducers } from 'redux'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import reducers from './reducers'
import sagas from './sagas'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['app'],
}

let sagaOptions = {}
let reactotron

if (process.env.NODE_ENV !== 'production') {
  reactotron = require('./utils/reactotron').default
  const sagaMonitor = reactotron.createSagaMonitor()
  sagaOptions = { sagaMonitor }
}

const sagaMiddleware = createSagaMiddleware(sagaOptions)

const enhancers = []

if (process.env.NODE_ENV !== 'production') {
  enhancers.push(reactotron.createEnhancer())
}

const reducer = combineReducers(reducers)

const store = configureStore({
  reducer: persistReducer(persistConfig, reducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }).concat(sagaMiddleware),
  enhancers,
})

export default store

export const persistor = persistStore(store)

sagaMiddleware.run(sagas)
